<template>
  <!--
    Loader global do painel: logo Eventfy com animação de traço + preenchimento
    (mesma arte do pré-loader de SSO em public/index.html), em loop contínuo.
    Usado como slot default do vue-loading-overlay (ver bootstrap.js/main2.js).
  -->
  <div ref="wrap" class="efy-loader">
    <svg viewBox="243 373 74 104" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <linearGradient id="efyG1"><stop offset="0%" stop-color="#fcb01c"/><stop offset="100%" stop-color="#ff2e2e"/></linearGradient>
        <linearGradient xlink:href="#efyG1" id="efyG2" x1="314.19" y1="295.35" x2="314.19" y2="358.37" gradientTransform="scale(0.7823,1.2783)" gradientUnits="userSpaceOnUse"/>
        <linearGradient id="efyG3"><stop offset="0%" stop-color="#03a1c1"/><stop offset="100%" stop-color="#065bab"/></linearGradient>
        <linearGradient xlink:href="#efyG3" id="efyG4" x1="293.27" y1="316.41" x2="293.27" y2="396.27" gradientTransform="scale(0.838,1.1933)" gradientUnits="userSpaceOnUse"/>
        <linearGradient id="efyG5"><stop offset="0%" stop-color="#01a8ba"/><stop offset="100%" stop-color="#035fa1"/></linearGradient>
        <linearGradient xlink:href="#efyG5" id="efyG6" x1="244.38" y1="379.72" x2="244.38" y2="446.18" gradientTransform="scale(1.0057,0.9943)" gradientUnits="userSpaceOnUse"/>
      </defs>
      <path class="efy-fill" style="--f:0.8s" d="m253.924,378.231 38.694,26.204c1.59,1.077 2.483,3.111 2.483,5.66 0,2.549-0.892,4.896-2.483,6.532l-38.694,39.796c-1.679,1.727-3.654,2.149-5.39,1.153-1.736-0.997-2.74-3.13-2.74-5.821v-66c0-2.691 1.004-5.177 2.74-6.783 1.736-1.606 3.711-1.878 5.39-0.741z" fill="url(#efyG2)"/>
      <path class="efy-fill" style="--f:0.9s" d="m256.825,393.534c17.5,11 35,22 52.5,33 2.158,1.357 3.368,3.547 3.368,6.096 0,2.549-1.21,4.739-3.368,6.096-17.5,11-35,22-52.5,33-2.279,1.432-4.958,1.508-7.314,0.206-2.355-1.302-3.718-3.611-3.718-6.302v-76.968c-0.04-2.951-0.176-5.715 1.377-8.017 1.784-2.642 4.615-4.376 7.604-1.837-7.236,4.731-0.998,12.94 2.05,14.726z" fill="url(#efyG4)"/>
      <path class="efy-fill" style="--f:1s" d="m256.825,393.534c17.5,11 35,22 52.5,33 1.846,1.16 2.998,2.93 3.293,5.013-10.342,7.521-24.124,12.112-39.257,12.112-9.976,0-19.364-1.995-27.567-5.509v-49.488c-0.04-2.951-0.176-5.715 1.377-8.017 1.784-2.642 4.615-4.376 7.604-1.837-7.236,4.731-0.998,12.94 2.05,14.726z" fill="url(#efyG6)"/>
      <path class="efy-draw s-orange" style="--dur:1s;--d:0s;--sf:1.2s" d="m253.924,378.231 38.694,26.204c1.59,1.077 2.483,3.111 2.483,5.66 0,2.549-0.892,4.896-2.483,6.532l-38.694,39.796c-1.679,1.727-3.654,2.149-5.39,1.153-1.736-0.997-2.74-3.13-2.74-5.821v-66c0-2.691 1.004-5.177 2.74-6.783 1.736-1.606 3.711-1.878 5.39-0.741z"/>
      <path class="efy-draw s-blue" style="--dur:1.2s;--d:0.1s;--sf:1.3s" d="m256.825,393.534c17.5,11 35,22 52.5,33 2.158,1.357 3.368,3.547 3.368,6.096 0,2.549-1.21,4.739-3.368,6.096-17.5,11-35,22-52.5,33-2.279,1.432-4.958,1.508-7.314,0.206-2.355-1.302-3.718-3.611-3.718-6.302v-76.968c-0.04-2.951-0.176-5.715 1.377-8.017 1.784-2.642 4.615-4.376 7.604-1.837-7.236,4.731-0.998,12.94 2.05,14.726z"/>
      <path class="efy-draw s-teal" style="--dur:0.8s;--d:0.2s;--sf:1.3s" d="m256.825,393.534c17.5,11 35,22 52.5,33 1.846,1.16 2.998,2.93 3.293,5.013-10.342,7.521-24.124,12.112-39.257,12.112-9.976,0-19.364-1.995-27.567-5.509v-49.488c-0.04-2.951-0.176-5.715 1.377-8.017 1.784-2.642 4.615-4.376 7.604-1.837-7.236,4.731-0.998,12.94 2.05,14.726z"/>
    </svg>
  </div>
</template>

<script>
const CYCLE_MS = 2000 // desenho + preenchimento do símbolo (termina ~1.6s)
const FADE_MS = 400

export default {
  name: 'eventfy-loader',
  data () {
    return { timers: [] }
  },
  mounted () {
    const el = this.$refs.wrap
    if (!el) return
    // Mede o comprimento real de cada traço para a animação de desenho
    el.querySelectorAll('.efy-draw').forEach(p => {
      p.style.setProperty('--len', p.getTotalLength())
    })
    this.loop(el)
  },
  beforeDestroy () {
    this.timers.forEach(t => clearTimeout(t))
  },
  methods: {
    loop (el) {
      el.classList.add('animate')
      this.timers.push(setTimeout(() => {
        el.style.transition = `opacity ${FADE_MS}ms ease`
        el.style.opacity = '0'
        this.timers.push(setTimeout(() => {
          el.classList.remove('animate')
          el.style.transition = 'none'
          // força reflow para reiniciar as animações CSS
          void el.offsetWidth
          el.style.opacity = '1'
          this.timers.push(setTimeout(() => this.loop(el), 120))
        }, FADE_MS))
      }, CYCLE_MS))
    }
  }
}
</script>

<style scoped>
.efy-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
}
.efy-loader svg {
  width: 84px;
  max-width: 40vw;
  height: auto;
}
.efy-loader >>> .efy-draw {
  fill: none !important;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: var(--len);
  stroke-dashoffset: var(--len);
}
.efy-loader >>> .efy-draw.s-text { stroke: #2c343b; stroke-width: .5; }
.efy-loader >>> .efy-draw.s-blue { stroke: #03a1c1; stroke-width: .8; }
.efy-loader >>> .efy-draw.s-orange { stroke: #fc7b23; stroke-width: .8; }
.efy-loader >>> .efy-draw.s-teal { stroke: #01a8ba; stroke-width: .8; }
.efy-loader >>> .efy-fill { opacity: 0; }
.efy-loader.animate >>> .efy-draw {
  animation:
    efyDraw var(--dur, 1.5s) var(--d, 0s) cubic-bezier(.65, 0, .35, 1) forwards,
    efyStrokeOut .3s var(--sf, 1.5s) ease forwards;
}
.efy-loader.animate >>> .efy-fill {
  animation: efyFillIn .4s var(--f, 1s) cubic-bezier(.33, 1, .68, 1) forwards;
}
@keyframes efyDraw { to { stroke-dashoffset: 0; } }
@keyframes efyFillIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes efyStrokeOut { to { stroke-opacity: 0; } }
</style>
